import React, { PropsWithChildren, useMemo } from 'react';
import { ConfigContext } from './ConfigContext';
import { ConfigProviderProps } from './ConfigContext.types';
import { ClientSideConfig } from 'types';

function ConfigProvider({ children, config }: ConfigProviderProps & PropsWithChildren) {
  const value = useMemo<ClientSideConfig>(() => config, [config]);

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}

export default ConfigProvider;